export default "__VITE_ASSET__aO9wKAqO__"